import {bootDevice} from "@/assets/js/SysExCommand";

const REPOSITORY = /^[A-Za-z0-9_.-]+\/[A-Za-z0-9_.-]+$/
const VERSION = /^v?(\d+)\.(\d+)\.(\d+)$/

export function normalizeFirmwareVersion(value) {
    const match = VERSION.exec(value || '')
    return match ? match.slice(1).map(Number).join('.') : null
}

export function firmwareUpdateState(currentVersion, latestVersion) {
    const current = normalizeFirmwareVersion(currentVersion)
    const latest = normalizeFirmwareVersion(latestVersion)
    if (!latest) return 'unknown-latest'
    if (!current) return 'unknown-current'
    const currentParts = current.split('.').map(Number)
    const latestParts = latest.split('.').map(Number)
    for (let index = 0; index < 3; index++) {
        if (currentParts[index] < latestParts[index]) return 'update-available'
        if (currentParts[index] > latestParts[index]) return 'newer-than-published'
    }
    return 'up-to-date'
}

export async function resolveFirmwareRelease(repo_link) {
    if (!navigator.onLine) {
        throw new Error('Firmware updates require an internet connection.')
    }
    if (!REPOSITORY.test(repo_link || '') || repo_link.includes('..')) {
        throw new Error('Firmware repository is not trusted.')
    }

    const response = await fetch(`https://api.github.com/repos/${repo_link}/releases/latest`, {headers: {
            "Accept": "application/vnd.github+json",
            "X-GitHub-Api-Version": "2022-11-28",
        }})

    if (!response.ok) {
        throw new Error(`Could not load the firmware release (${response.status}).`)
    }

    const data = await response.json()
    const tag = typeof data.tag_name === 'string' ? data.tag_name : ''
    const releasePrefix = `https://github.com/${repo_link}/releases/download/${encodeURIComponent(tag)}/`
    const firmwareAssets = (data.assets || []).filter((asset) =>
        typeof asset.name === 'string' && asset.name.toLowerCase().endsWith('.uf2') &&
        typeof asset.browser_download_url === 'string' && asset.browser_download_url.startsWith(releasePrefix)
    )
    if (firmwareAssets.length !== 1) {
        throw new Error('The latest release must contain exactly one trusted .uf2 firmware file.')
    }
    return {
        tag,
        version: normalizeFirmwareVersion(tag),
        url: firmwareAssets[0].browser_download_url
    }
}

export function installFirmwareRelease(release, device, repo_link) {
    if (!device) throw new Error('Connect Biotron before starting the update.')
    const prefix = `https://github.com/${repo_link}/releases/download/${encodeURIComponent(release && release.tag)}/`
    if (!REPOSITORY.test(repo_link || '') || !release || typeof release.url !== 'string' ||
        !release.url.startsWith(prefix)) {
        throw new Error('Firmware release was not resolved safely.')
    }

    // Enter BOOT mode only after the online firmware file has been resolved.
    bootDevice(device)
    window.location.assign(release.url)
}

export async function LoadFirmware(repo_link, device) {
    const release = await resolveFirmwareRelease(repo_link)
    // Preserve the existing download-only fallback used by other device pages.
    // Biotron's version-aware flow calls installFirmwareRelease and requires a device.
    bootDevice(device)
    window.location.assign(release.url)
}
